import React, { useEffect, useContext, useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { UserManagentContext } from "../../customHooks/dataProviders/UserManagementProvider";
import { ssoMicrosoftLogin, GetRoleNamesByUsername } from "../../service/api/login/loginService";

const SSOHandler = () => {
    const { instance, accounts, inProgress } = useMsal();
    const navigate = useNavigate();
    const { setuserManagementData } = useContext(UserManagentContext);

    const handleSsoSync = useCallback(async (account) => {
        const isAuthenticated = localStorage.getItem("jwtToken");
        const isProcessing = sessionStorage.getItem("sso_sync_active_v2");

        if (isAuthenticated) {
            console.log("Global SSO Handler: App already authenticated with JWT.");
            return;
        }
        if (isProcessing) {
            console.log("Global SSO Handler: Sync already in progress...");
            return;
        }

        sessionStorage.setItem("sso_sync_active_v2", "true");
        console.log("Global SSO Handler: Starting backend handshake for:", account.username);

        try {
            console.log("Global SSO Handler: Projecting MSAL token silently...");
            const loginResponse = await instance.acquireTokenSilent({
                scopes: ["openid", "profile", "email", "User.Read"],
                account: account,
            });

            const email = account.username;
            const name = account.name || email;
            const accessToken = loginResponse.accessToken;

            console.log("Global SSO Handler: Calling backend ssoMicrosoftLogin API...");
            const data = await ssoMicrosoftLogin(accessToken, email, name);

            if (data.status === "OK" || data.jwtToken) {
                console.log("Global SSO Handler: Backend login SUCCESS");
                const { userId, jwtToken, roles } = data;
                localStorage.setItem("jwtToken", jwtToken);
                localStorage.setItem("expiryTime", dayjs().add(30000000, "milliseconds").toISOString());
                localStorage.setItem("userId", userId);
                localStorage.setItem("userMailId", email);

                const roleNames = await GetRoleNamesByUsername(email);
                setuserManagementData({ roleTypes: roles, roleNames });
                localStorage.setItem("roleNames", JSON.stringify(roleNames));

                console.log("Global SSO Handler: Navigating to /home");
                navigate("/home");
            } else {
                console.error("Global SSO Handler: Backend login failed status:", data.status);
            }
        } catch (error) {
            console.error("Global SSO Handler: Fatal error during sync:", error);
        } finally {
            sessionStorage.removeItem("sso_sync_active_v2");
        }
    }, [instance, navigate, setuserManagementData]);

    useEffect(() => {
        console.log("Global SSO Handler State:", { inProgress, accountsCount: accounts.length });

        if (inProgress === "none" && accounts.length > 0) {
            handleSsoSync(accounts[0]);
        }
    }, [accounts, inProgress, handleSsoSync]);

    return null; // This component doesn't render anything visible
};

export default SSOHandler;
